<template>
  <div>
    <div
      class="text-center"
      v-if="!dataLoaded"
    >
      <v-progress-circular
        class="mt-6"
        color="primary"
        :size="50"
        indeterminate
      />
    </div>

    <div
      class="mt-4"
      v-show="dataLoaded"
    >
      <TitleCard
        :is-show-mode="isShowMode"
        :is-process-mode="isProcessMode"
        :is-edit-mode="isEditMode"
        :disabled="invalid"
        :saveLoading="saveBtnLoading"
        :selected-item="publicOrganizationParticipation"
        :is-no-changes="isNoChanges"
        @save="savePublicOrganizationParticipation"
      />

      <v-row
        class="mb-0 mt-2"
        style="margin-right: -14px"
      >
        <v-col
          ref="workList"
          cols="12"
          class="pt-1 pb-2 pr-2 overflow-auto"
        >
          <WorkTitleCard :title="workTypeRusName(workTypeName.PublicOrganizationParticipation)" />

          <AuthorsCard
            title="Сотрудник"
            class="mt-4"
            :selected-item.sync="publicOrganizationParticipation.commonWork.authors"
            :is-show-mode="isShowMode"
            hide-share
            hide-not-found-author
            @updateInvalid="updateAuthorsInvalid"
          />

          <PublicOrganizationParticipationCard
            class="mt-4"
            title="Основная информация"
            :selected-item.sync="publicOrganizationParticipation"
            :is-show-mode="isShowMode"
            @updateInvalid="updatePublicOrganizationParticipationInvalid"
          />

          <CommentCard
            v-if="Boolean(publicOrganizationParticipation.commonWork.comment)"
            class="mt-4"
            :comment="publicOrganizationParticipation.commonWork.comment"
          />

          <CreatorCard :creator-name="publicOrganizationParticipation.commonWork.creator.fullName" />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { publicOrganizationParticipationApi } from '@/api'
import TitleCard from '../../components/Works/elements/TitleCard'
import { PublicOrganizationParticipation } from '../../models'
import PublicOrganizationParticipationCard from '../../components/Works/PublicOrganizationParticipation/PublicOrganizationParticipationCard'
import AuthorsCard from '../../components/Works/elements/AuthorsCard'
import CommentCard from '@/components/Works/elements/CommentCard.vue'
import { mapActions, mapGetters } from 'vuex'
import { workListHeight } from '@/mixins/workListHeight'
import WorkTitleCard from '@/components/Works/elements/WorkTitleCard.vue'
import CreatorCard from '@/components/Works/elements/CreatorCard.vue'
import { dictionaryNames, workMode, workTypeName } from '@/scripts/consts'

export default {
  name: 'PublicOrganizationParticipationParent',

  metaInfo() {
    return {
      title: this && this.workTypeRusName(workTypeName.PublicOrganizationParticipation)
    }
  },

  components: {
    CreatorCard,
    WorkTitleCard,
    CommentCard,
    AuthorsCard,
    PublicOrganizationParticipationCard,
    TitleCard
  },

  mixins: [workListHeight],

  created() {
    this.isShowMode = this.$route.params.mode === workMode.Show
    this.isProcessMode = this.$route.params.mode === workMode.Process
    this.isEditMode = this.$route.params.mode === workMode.Edit
    this.getData()
  },

  data: () => ({
    publicOrganizationParticipation: new PublicOrganizationParticipation(),
    selectedItem: null,
    isShowMode: false,
    isEditMode: false,
    isProcessMode: false,
    saveBtnLoading: false,
    dataLoaded: false,
    publicOrganizationParticipationInvalid: false,
    authorsInvalid: false,
    isNoChanges: true
  }),

  computed: {
    workTypeName() {
      return workTypeName
    },
    ...mapGetters('workTypes', ['workTypeByName', 'workTypeRusName']),

    invalid() {
      return this.authorsInvalid || this.publicOrganizationParticipationInvalid
    }
  },

  methods: {
    ...mapActions('dictionaries', ['getDictionaries', 'addInDictionary']),
    ...mapActions('workTypes', ['getWorkTypes']),

    async getData() {
      if (!this.isShowMode) await this.getDictionaries([dictionaryNames.Year, dictionaryNames.ParticipationStatus])
      await this.getWorkTypes()
      await this.getPublicOrganizationParticipation()
      this.dataLoaded = true
      this.isNoChanges = true
    },

    async getPublicOrganizationParticipation() {
      try {
        if (this.$route.params?.id !== '0') {
          const data = await publicOrganizationParticipationApi.get(this.$route.params?.id)
          this.publicOrganizationParticipation = new PublicOrganizationParticipation(data)
        }
      } catch (e) {
        console.log(e)
        this.showErrorMessage(e, 'Не удалось получить данные по работе')
      }
    },

    async savePublicOrganizationParticipation(isThrowError = false) {
      try {
        this.saveBtnLoading = true

        if (!this.publicOrganizationParticipation.id)
          this.publicOrganizationParticipation.commonWork.workType = this.workTypeByName(
            workTypeName.PublicOrganizationParticipation
          )

        const body = this.publicOrganizationParticipation.getForAPI()

        const data = this.publicOrganizationParticipation.id
          ? await publicOrganizationParticipationApi.update(body)
          : await publicOrganizationParticipationApi.create(body)

        if (!this.publicOrganizationParticipation.id)
          await this.$router.replace('/works/publicOrganizationParticipation/edit/' + data.id)

        this.publicOrganizationParticipation = new PublicOrganizationParticipation(data)

        this.$toast.info('Работа успешно сохранена')
        queueMicrotask(() => (this.isNoChanges = true))
      } catch (e) {
        console.log(e)
        this.showErrorMessage(e, 'Ошибка сохранения работы')
        if (isThrowError) throw new Error('Ошибка сохранения')
      } finally {
        this.saveBtnLoading = false
      }
    },

    async updateAuthorsInvalid(val) {
      this.authorsInvalid = val
      this.isNoChanges = false
    },

    async updatePublicOrganizationParticipationInvalid(val) {
      this.publicOrganizationParticipationInvalid = val
      this.isNoChanges = false
    }
  },

  watch: {
    dataLoaded() {
      this.setWorkListHeight()
    }
  },

  provide: function () {
    return {
      saveWork: this.savePublicOrganizationParticipation
    }
  }
}
</script>

<style scoped></style>
